import { useTranslation } from '@bcba/react-hooks';
import { RepresentativePosition } from '@bcba/types';
import { Page, Text, View, Document } from '@react-pdf/renderer';
import { SignupFormState } from '../../context/useSignUpContext';
import Footer from './Footer';
import Form from './Form';
import { styles } from './styles';
import Items from './Items';
import Header from './Header';

interface MyDocumentProps {
  legalRepresentatives?: SignupFormState['legalRepresentatives'];
  companyName?: string;
  companyProvinceName?: string;
  companyLocalityName?: string;
  companyStreetName?: string;
  companyStreetNumber?: string;
  companyFiscalId?: string;
  userEmail?: string;
  userFiscalId?: string;
  userFirstName?: string;
  userLastName?: string;
  userPhone?: string;
}

export const MyDocument = (props: MyDocumentProps) => {
  const {
    legalRepresentatives,
    companyName,
    companyProvinceName,
    companyLocalityName,
    companyStreetName,
    companyStreetNumber,
    companyFiscalId,
    userEmail,
    userFiscalId,
    userFirstName,
    userLastName,
    userPhone,
  } = props;
  const { t } = useTranslation();

  const reps = legalRepresentatives?.map((r) => {
    return {
      fullName: `${r.firstName} ${r.lastName}`,
      position: r.position as RepresentativePosition,
    };
  });

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Header />
        <View>
          <Text
            style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: 10 }}
          >
            Legajo Digital
          </Text>
          <Text style={{ fontSize: '14px', color: 'gray', marginBottom: 20 }}>
            Solicitud de acceso
          </Text>
          <Text style={styles.text}>
            El/Los que suscribe/n la presente{' '}
            <Text style={styles.boldText}>
              {reps?.map((r) => `${r.fullName},${' '}`)}
            </Text>
            en carácter de{' '}
            <Text style={styles.boldText}>
              {reps?.map(
                (r) =>
                  `${t(`businessSignup.form.representativePosition.${r.position}`)},${' '}`,
              )}
            </Text>
            de la firma <Text style={styles.boldText}>{companyName}</Text> CUIT{' '}
            <Text style={styles.boldText}>{companyFiscalId}</Text>, con
            domicilio fiscal en{' '}
            <Text style={styles.boldText}>
              {companyStreetName + ' ' + companyStreetNumber}
            </Text>{' '}
            de la ciudad de{' '}
            <Text style={styles.boldText}>{companyLocalityName}</Text>,
            provincia de{' '}
            <Text style={styles.boldText}>{companyProvinceName}</Text>,
            autorizo/amos al administrador y/o demás personas que este designe,
            a acceder a la Plataforma BC Explorer, dar de alta y actualizar el
            Legajo Digital de esta empresa y gestionar los productos y servicios
            que en el futuro se contraten y se operen por esta plataforma, bajo
            los términos y condiciones de la Solicitud de Adhesión, a la que
            también adheriremos con posterioridad al presente.
          </Text>
          <Items />
        </View>
        <Footer />
      </Page>
      <Page size="A4" style={styles.page}>
        <Header />
        <Form
          userLastName={userLastName}
          userFirstName={userFirstName}
          userFiscalId={userFiscalId}
          userPhone={userPhone}
          userEmail={userEmail}
        />
        <Text
          style={{
            color: '#344054',
            paddingVertical: '24px',
            fontSize: '10px',
          }}
        >
          En la certificación el Escribano deberá indicar los datos de identidad
          del/los firmante/s, carácter en el que actúa/n, instrumento en el que
          justifica su representación (en caso de actas indicar los datos de la
          misma y los de rúbrica del libro en el que se asiente; y en caso de
          poder, los datos de la escritura y dejando constancia que cuenta con
          facultades que le permitan otorgar esta autorización) y datos de la
          empresa a la que pertenece (denominación, CUIT y datos de inscripción
          si corresponde, detallando Estatuto o Contrato Constitutivo y las
          reformas estatutarias existentes). Todos los datos precedentemente
          descriptos deberán contar entonces con la certificación y la
          correspondiente Legalización del Colegio de Escribano al que
          pertenezca.
        </Text>
        <Footer />
      </Page>
    </Document>
  );
};

export default MyDocument;
